import {Component, OnDestroy, OnInit} from '@angular/core';
import {HeaderService} from '../../../../../services/header-service';
import {Icons} from '../../../../../model/icon';
import {SectionComponent} from '../../../../elements/section/section.component';
import {DestinationsCountriesComponent} from '../destinations-countries/destinations-countries.component';
import {Location, NgIf} from '@angular/common';
import {MainBestHotelsComponent} from '../../../main/items/main-best-hotels/main-best-hotels.component';
import {MainDestinationsComponent} from '../../../main/items/main-destinations/main-destinations.component';
import {Country} from '../../../../../model/country';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {MainBusyBeeComponent} from '../../../main/items/main-busy-bee/main-busy-bee.component';
import {Card,  CardsArray,} from '../../../../../model/cards';
import {TitleBackgroundComponent} from '../../../../elements/title-background/title-background.component';
import {RunningLineComponent} from '../../../../elements/running-line/running-line.component';
import {Text} from '../../../../../model/text';
import {SectionScrollerComponent} from '../../../../elements/section-scroller/section-scroller.component';
import {ContinentService} from '../../../../../services/continent-service';
import {CountryService} from '../../../../../services/country-service';
import {LocationDto} from '../../../../../model/continent';
import {LoopedSliderComponent} from '../../../../elements/looped-slider/looped-slider.component';
import {environment} from '../../../../../environments/environment';
import {PaginationParams} from '../../../../../model/pagination';
import {HotelDtoService} from '../../../../../services/hotel-dto-service';
import {Continent} from '../../../../../model/circle';
import {FooterService} from '../../../../../services/footer-service';
import {RouteService} from '../../../../../services/route-service';
import {NavigationService} from '../../../../../services/navigation-service';
import {getCssNumber} from '../../../../../functions/getCssNumber';
import {findIconByCss, findTextByCss} from '../../../../../functions/findIconByAlt';
import {distinctUntilChanged, filter} from 'rxjs';
import {findLastNumber} from '../../../../../functions/getDays';
import {AdminPreviewComponent} from '../../../../elements/admin-preview/admin-preview.component';
import {TokenStorageService} from '../../../../../services/token.storage.service';
import {findFirstCountry, findFirstCountryUrl} from '../../../../../functions/findFirstCityUrl';
import {
  BackgroundLoopedSliderComponent
} from '../../../../elements/background-looped-slider/background-looped-slider.component';
import {getFirstSentence} from '../../../../../functions/getFirstSentence';
import {MenuService} from '../../../../../services/menu-services';
import {LoadingService} from '../../../../../services/loading-service';

@Component({
  selector: 'app-destination-page',
  imports: [
    SectionComponent,
    DestinationsCountriesComponent,
    MainBestHotelsComponent,
    MainDestinationsComponent,
    MainBusyBeeComponent,
    TitleBackgroundComponent,
    RunningLineComponent,
    SectionScrollerComponent,
    NgIf,
    LoopedSliderComponent,
    AdminPreviewComponent,
    BackgroundLoopedSliderComponent,
  ],
  templateUrl: './destination-page.component.html',
  standalone: true,
  styleUrl: './destination-page.component.scss'
})
export class DestinationPageComponent implements OnInit, OnDestroy{
  constructor(private router: Router,
              private route: ActivatedRoute,
              protected interfaceService: HeaderService,
              public location: Location,
              protected continentService: ContinentService,
              protected countryService: CountryService,
              protected routeService: RouteService,
              protected hotelService: HotelDtoService,
              public footerService: FooterService,
              public navigationService: NavigationService,
              protected tokenStorageService: TokenStorageService,
              protected menuService: MenuService,
              public loadingService: LoadingService,) {}

  routeSub: any;
  navigationSub: any;

  border: boolean = false;

  tab: boolean = false;
  url: string = ''
  id: number = 9;
  sliderCards: Card[] = [];
  routeCards: Card[] = [];
  countryCards: Card[] = [];
  hotelCards: Card[] = [];
  additionalCards: Card[] = [];
  loading: boolean = false;
  firstLoading: boolean = false;
  loadingCircle: boolean = false;
  typeContent: string | undefined = undefined;

  grid: number = 4.2;

  countryPaginationParams: PaginationParams = {
    query: '',
    pageSize: 100,
    pageNumber: 0,
    sort: ''
  };

  routePaginationParams: PaginationParams = {
    query: '',
    pageSize: 100,
    pageNumber: 0,
    sort: '',
    continentId: ''
  };

  hotelPaginationParams: PaginationParams = {
    query: '',
    pageSize: 100,
    pageNumber: 0,
    sort: 'rating:asc',
    continentId: ''
  };

  countries: Country[] = [];

  adminDisplay: boolean = false;
  uncorrectedUrl: boolean = false;
  displayPageFalse: boolean = false;
  isMobile: boolean = false;

  continentDto: LocationDto = new LocationDto();
  countriesDto: LocationDto[] = [];
  routesDto: LocationDto[] = [];

  continentTitle: string[] = [];

  destinationBusyByTitle: Text[] = [
    {text: ['Стоит  ', 'Recommended   '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['увидеть', ' '], },
  ];

  destinationBestHotelsTitle: Text[] = [
    {text: ['Рекомендуемые ', 'Finest '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['отели', 'Hotels']}
  ];

  routesBusyByTitle: Text[] = [
    {text: ['Варианты ', 'Travel '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['маршрутов', 'Ideas']}
  ];


  ngOnInit() {
    if (window.innerWidth < 769) {
      this.isMobile = true;
      this.menuService.setMobileSpecialStyle(true);
      if (window.innerWidth < 456) {
        this.grid = 1.3;
      } else {
        this.grid = 2.1;
      }
    }
    this.interfaceService.setPageInterface('header-container-white');
    this.interfaceService.setHeaderStyle(true);
    this.routeSub = this.route.paramMap.subscribe(params => {
      const url = params.get('name')?.toLowerCase() || '';
      this.getCorrectTitle(url);
    });
    this.navigationSub = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        const url = this.route.snapshot.paramMap.get('name')?.toLowerCase() || '';
        this.getCorrectTitle(url);
      });
    if (window.innerWidth < 769) {
      this.tab = true;
    }
    if (window.innerWidth < 576) {
      // this.destinationBusyByTitle = [
      //   {text: ['Exclusive ', 'Exclusive'], textTransform: 'uppercase'},
      // ];
      // this.destinationBestHotelsTitle = [
      //   {text: ['Luxury ', 'Luxury '], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
      //   {text: ['Stays', 'Stays'], textTransform: 'uppercase'}
      // ]
    }
  }

  ngOnDestroy() {
    this.menuService.setMobileSpecialStyle(false);
    this.interfaceService.setHeaderStyle(false);
    this.footerService.setFooterColor('rgba(57, 122, 158, 1)');
    this.footerService.setFooterImage('');
    this.footerService.setFooterStyle('');
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    if (this.navigationSub) {
      this.navigationSub.unsubscribe();
    }
  }

  getCorrectLocation() {
    if (this.continentDto == null) {
      return new LocationDto(this.countryService.getRandom())
    } else {
      this.continentDto.destinationsText = [{text: ['НАПРАВЛЕНИЕ', 'DESTINATION']}]
      return this.continentDto
    }
  }

  goToDestination(continent: Continent) {
    const url = '/destinations/' + continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url],{relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

  getCorrectTitle(url: string) {
    if (this.url !== url) {
      this.url = url.toLowerCase();
      this.resetData();
      this.getContinent(this.url);
    }
  }

  resetData() {
    this.loading = true;
    this.checkLoading();
    this.sliderCards = [];
    this.routeCards = [];
    this.countryCards = [];
    this.hotelCards = [];
    this.additionalCards = [];
    this.continentDto = new LocationDto();
    this.countriesDto = [];
    this.routesDto = [];
  }

  getContinent(url: string) {
    this.loading = true;
    this.checkLoading();
    this.continentService.getContinentByUrl(url).subscribe((data) => {
      this.continentDto = data ?? new LocationDto();
      this.continentDto.button = false;
      this.typeContent = this.continentDto.id?.toString();
      if (this.continentDto.url === '') {
        if (this.tokenStorageService.getToken() !== undefined) {
          this.adminDisplay = true;
          this.uncorrectedUrl = true;
        } else {
          this.navigationService.backOrHome();
        }
      }
      if (this.continentDto.displayPage === false) {
        if (this.tokenStorageService.getToken() !== undefined) {
          this.adminDisplay = true;
          this.displayPageFalse = true;
        } else {
          this.navigationService.backOrHome();
        }
      }
      this.id = this.continentDto.id ?? 0;
      this.routePaginationParams.continentId = this.continentDto.id?.toString() ?? '';
      this.footerService.setFooterColor(this.continentDto.footerColor ?? 'rgba(57, 122, 158, 1)');
      this.footerService.setFooterImage(this.continentDto.footerImage ?? '');
      this.footerService.setFooterStyle(this.continentDto.cssStyleFooterImage ?? '');
      this.continentTitle = [this.continentDto.titleRu ?? '', this.continentDto.titleEn ?? ''];
      this.additionalCards = this.continentDto.additionalEvents.map(event => new Card({
        id: event.id,
        title: [event.titleRu ?? '', event.titleEn ?? ''],
        text: [event.descriptionRu ?? '', event.descriptionEn ?? ''],
        img: event.image ? environment.s3Prefix + event.image : '/app/assets/images/desert.jpg',
        style: event.cssStyle ?? '',
        flex: '',
        tag: event.tag,
        tagRu: event.tagRu,
        anotherButtonText: [{text: ['Исследовать', 'Discover']}]
      }));
      this.sliderCards = this.continentDto.carousels.map(v => new Card({
        id: v.id,
        title: [],
        text: [],
        img: environment.s3Prefix + v.image,
        style: v.cssStyle ?? '',
        flex: '',
        cssStyle: v.cssStyle,
        cloud: {
          title: [v.cloudTitleRu ?? '', v.cloudTitleEn ?? ''],
          text: [{text: [v.cloudDescriptionRu ?? '', v.cloudDescriptionEn ?? '']}],
          link: findTextByCss(v.cssStyle, 'link'),
          icon1: findIconByCss(v.cssStyle, 'icon', 1),
          icon2: findIconByCss(v.cssStyle, 'icon', 2),
          icon3: findIconByCss(v.cssStyle, 'icon', 3),
          textEn1: findTextByCss(v.cssStyle, 'textEn', 1),
          textEn2: findTextByCss(v.cssStyle, 'textEn', 2),
          textEn3: findTextByCss(v.cssStyle, 'textEn', 3),
          textRu1: findTextByCss(v.cssStyle, 'textRu', 1),
          textRu2: findTextByCss(v.cssStyle, 'textRu', 2),
          textRu3: findTextByCss(v.cssStyle, 'textRu', 3),
          paddingTop: 0,
          top: getCssNumber(v.cssStyle, 'top') ?? 50,
          left: getCssNumber(v.cssStyle, 'left') ?? 50,
        }
      }));
      this.countryCards = this.continentDto.events.map(c => new Card({
        id: c.id,
        title: [c.titleRu ?? '', c.titleEn ?? ''],
        text: [c.descriptionRu ?? '', c.descriptionEn ?? ''],
        img: c.image ? environment.s3Prefix + c.image : '/app/assets/images/desert.jpg',
        style: c.cssStyle ?? '',
        flex: '',
        button: true,
        link: '/feedback',
        anotherButtonText: [{text: ['Исследовать', 'Discover']}],
        feedValue: [{text: ['Другое', 'Other']}],
      }));
      this.countryService.getCountryListByContinent(this.countryPaginationParams, this.continentDto.id ?? 0).subscribe((data) => {
        this.countriesDto = data.content?.filter((v) => v.displayPage === true) ?? [];
        this.countriesDto.forEach(country => {
          const eventCards = country.events.map(event => new Card({
            id: event.id,
            title: [event.titleRu ?? '', event.titleEn ?? ''],
            text: [event.descriptionRu ?? '', event.descriptionEn ?? ''],
            img: event.image ? environment.s3Prefix + event.image : '/app/assets/images/desert.jpg',
            style: event.cssStyle ?? '',
            flex: '',
            tag: event.tag,
            tagRu: event.tagRu
          }));
          this.countryCards.push(...eventCards);
        });
        this.routeService.getRouteList(this.routePaginationParams).subscribe((data) => {
          this.routesDto = data.content ?? [];
          this.routeCards = this.routesDto.map(v => {
            let countryUrl = 'location'
            const country = findFirstCountryUrl(v.points);
            if (country !== undefined) {
              countryUrl = country
            }
            const routeUrl = v.url
            const link = `/destinations/${this.continentDto.url}/${countryUrl}/route/${routeUrl}`;
            let countEn = '';
            let countRu = '';
            const descr = findFirstCountry(v.points);
            const desRu = descr?.descriptionRu ?? '';
            const desEn = descr?.descriptionEn ?? '';
            v.points.forEach((p) => {
              if (p.titleEn !== undefined && p.titleEn.length > 0) {
                countEn = findLastNumber(p.titleEn, 'en');
              }
              if (p.titleRu !== undefined && p.titleRu.length > 0) {
                countRu = findLastNumber(p.titleRu, 'ru');
              }
            })
            return new Card({
              id: v.id,
              title: [v.titleRu ?? '', v.titleEn ?? ''],
              text: [desRu, desEn],
              img: v.image ? environment.s3Prefix + v.image : '/app/assets/images/desert.jpg',
              style: '',
              flex: '',
              tag: countEn,
              tagRu: countRu,
              button: true,
              link: link,
              anotherButtonText: [{text: ['Исследовать', 'Discover']}]
            });
          });
        })
      });
      this.hotelPaginationParams.continentId = this.continentDto.id?.toString();
      this.hotelService.getHotelList(this.hotelPaginationParams).subscribe((data) => {
        this.hotelCards = (data.content ?? []).map(v => {
          const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
          let link: string | null;
          if (v.city?.country?.continent?.url.length != undefined && v.city?.country?.url != undefined) {
            link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
              v.city?.url + '/' + v?.url;
          } else {
            link = null
          }
          let descrRu = '';
          let descrEn = '';
          if (v.descriptionRu !== undefined) {
            descrRu = getFirstSentence(v.descriptionRu);
          }
          if (v.descriptionEn !== undefined) {
            descrEn = getFirstSentence(v.descriptionEn);
          }
          return new Card(
            {
              title: ['', ''],
              text: [v.titleRu, v.titleEn],
              img: path,
              style: v.backgroundStyle?.toString() ?? '',
              button: false,
              link: link,
              rating: v.rating ?? 0,
              anotherButton: true,
              anotherHotelButton: true,
              anotherButtonText: [{text: [descrRu, descrEn]}],
            },
          )
        });
      });
      const ru = this.getExclusiveText(this.continentDto.titleRu);
      setTimeout(() => {
        this.loading = false;
        this.checkLoading();
      }, 500);
    });
  }

  borderEmit(event: boolean) {
    this.border = event;
  }

  getExclusiveText(continent: string){
    if (continent === 'Ближний Восток' || continent === 'Австралия & Океания') {
      return `Эксклюзивный ${continent}`;
    } else {
      return `Эксклюзивная ${continent}`;
    }
  }

  loadingEmit(event: boolean) {
    this.firstLoading = event;
    this.checkLoading();
  }

  loadCircle(event: boolean) {
    this.loadingCircle = event;
    this.checkLoading();
  }

  checkLoading() {
    if (this.loading || this.firstLoading || this.loadingCircle) {
      this.loadingService.setLoadingValue(true);
    }
    if (!this.loading && !this.firstLoading && !this.loadingCircle) {
      this.loadingService.setLoadingValue(false);
    }
  }

  protected readonly Icons = Icons;
  protected readonly CardsArray = CardsArray;
}
